import React, { useState } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import CookiePolicy from '../pages/CookiePolicy';
import './LegalModal.css';

const Footer = ({ t }) => {
  const [activePolicy, setActivePolicy] = useState(null);
  const { lang } = useLanguage();

  return (
    <>
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">KRYPTON9</h3>
            <p className="body-medium text-secondary">{t.footer.tagline}</p>
          </div>
          
          <div className="footer-links">
            <button onClick={() => setActivePolicy('privacy')} className="footer-link body-small" data-testid="footer-privacy-link">
              {t.footer.links.privacy}
            </button>
            <button onClick={() => setActivePolicy('terms')} className="footer-link body-small" data-testid="footer-terms-link">
              {t.footer.links.terms}
            </button>
            <button onClick={() => setActivePolicy('cookies')} className="footer-link body-small" data-testid="footer-cookies-link">
              {t.footer.links.cookies}
            </button>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="caption">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
    <DialogPrimitive.Root open={Boolean(activePolicy)} onOpenChange={(open) => { if (!open) setActivePolicy(null); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="legal-modal-overlay" />
        <DialogPrimitive.Content className="legal-modal" data-testid="legal-modal">
          <DialogPrimitive.Description className="sr-only">
            {activePolicy ? t.footer.links[activePolicy] : ''}
          </DialogPrimitive.Description>
          {activePolicy === 'privacy' && <PrivacyPolicy embedded />}
          {activePolicy === 'terms' && <TermsOfService embedded />}
          {activePolicy === 'cookies' && <CookiePolicy embedded />}
          <DialogPrimitive.Close className="legal-modal-close" aria-label={lang === 'en' ? 'Close' : 'Sluiten'} data-testid="legal-modal-close">
            <X size={18} aria-hidden="true" />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
    </>
  );
};

export default Footer;
